const conceptMainBg = (() => {
  const pageConcept = (document.getElementById("pageConcept") != null);
  if (pageConcept) {


    let sW = window.innerWidth;
    let sH = window.innerHeight;

    if (sW >= 768) {
      sH = window.innerHeight;
    } else {
      sH = window.outerHeight
    }


    let jsSecBg = document.getElementById("jsSecBg")
    let bgWrap = jsSecBg.querySelector(".js-bg-wrap")
    let coverWrap = jsSecBg.querySelector(".js-cover-wrap")

    let jsSecSakuraMirai = document.getElementById("jsSecSakuraMirai")


    jsSecBg.style.height = `${sH}px`


    // 画面高さとbgWrapの高さ計算
    let bgWrapH = bgWrap.offsetHeight;
    let moveGap = bgWrapH - sH
    // console.log(moveGap);

    if (sW < 768) {
      moveGap = 0
    }

    gsap.to(bgWrap, {
      top: -moveGap,
      scrollTrigger: {
        trigger: 'body',
        start: 'top top',
        endTrigger: jsSecSakuraMirai,
        end: 'top bottom',
        scrub: true,
        onEnter: () => {
          // console.log('enter')
        },
        onLeave: () => {
          // console.log('leave')
          coverWrap.classList.add('act')
        },
        onEnterBack: () => {
          // console.log('enter back')
          coverWrap.classList.remove('act')
        },
        onLeaveBack: () => {
          // console.log('leave back')
        },
        // markers: true,
      }
    });


    gsap.to(bgWrap, {
      scale: 1.2,
      filter: "blur(10px)",
      scrollTrigger: {
        trigger: jsSecSakuraMirai,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onEnter: () => {
          // console.log('enter')
        },
        onLeave: () => {
          // console.log('leave')
          jsSecBg.classList.add('none')
        },
        onEnterBack: () => {
          // console.log('enter back')
          jsSecBg.classList.remove('none')
        },
        onLeaveBack: () => {
          // console.log('leave back')
        },
        // markers: true,
      }
    });




  }
})()
export default conceptMainBg;